import { render } from "./ProcessDisplayDrawerPanel.vue?vue&type=template&id=6f85f585&scoped=true"
import script from "./ProcessDisplayDrawerPanel.vue?vue&type=script&lang=js"
export * from "./ProcessDisplayDrawerPanel.vue?vue&type=script&lang=js"

import "./ProcessDisplayDrawerPanel.vue?vue&type=style&index=0&id=6f85f585&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f85f585"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QExpansionItem,QList,QItem,QItemSection,QSelect,QIcon});
